import React from 'react'
import _ from 'underscore'
import { Textarea as UITextarea } from '@/components/ui/textarea'
import { cn } from '@/lib/utils'

// The shadcn Textarea auto-grows via field-sizing:content, which replaces
// the legacy `expands` JS resize behaviour.
class DebouncedTextarea extends React.Component {

  constructor(props) {
    super(props)

    this.state = {
      value: this.props.value || '',
      dirty: false
    }
  }

  inputRef = React.createRef()

  componentDidMount() {
    this.debouncedUpdate = _.debounce(this.update, 1000)
  }

  componentWillReceiveProps(nextProps) {
    if (this.state.dirty) {
      if (nextProps.value === this.state.value) {
        this.setState({dirty: false})
      }
    }
  }

  onChange = () => {
    this.setState({value: this.inputRef.current.value, dirty: true})
    this.debouncedUpdate(this.inputRef.current.value)
  }

  onKeyDown = (e) => {
    if (e.key === 'Backspace') {
      if (this.state.value === '') {
        if (this.props.onClear) {
          this.props.onClear()
        }
      }
    }
    else if (e.key === 'Enter') {
      if (this.props.onEnter) {
        this.props.onEnter(e)
      }
    }
  }

  update = (value) => {
    this.props.onChange(value)
  }

  onBlur = () => {
    if (this.props.onBlur) {
      this.props.onBlur(this.inputRef.current.value)
    }
  }

  render() {
    // Strip the legacy bootstrap default; anything else passes through.
    const classes = (this.props.classNames || '')
      .split(/\s+/)
      .filter((token) => token && token !== 'form-control')

    const rows = parseInt(this.props.rows || '6', 10)

    return (
      <UITextarea
        ref={this.inputRef}
        spellCheck="false"
        rows={rows}
        // field-sizing:content ignores the rows attribute, so translate it
        // into the starting height (1lh per row + py-3 padding) — via a class
        // so callers (e.g. the task rows) can still override it. resize-y
        // restores the native drag handle legacy textareas always had.
        style={{ '--rows': rows }}
        className={cn('min-h-[calc(var(--rows)*1lh+1.5rem)] resize-y', classes, this.state.dirty && 'bg-[#ffffe6]!')}
        placeholder={this.props.placeholder}
        value={this.state.value}
        onChange={this.onChange}
        onKeyDown={this.onKeyDown}
        onBlur={this.onBlur}
      />
    )
  }
}

export default DebouncedTextarea
